/// <amd-module name="Environments/EnvironmentDetails/Actions/EnvironmentChecksActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { EnvironmentInstance } from "DistributedTask/Client/Contracts/TaskAgent";

export class EnvironmentChecksActions extends ActionsHubBase {

    public static getKey(): string {
        return "environments-checks-actions";
    }

    public initialize(instanceId?: string) {
        this._setEnvironment = new Action<EnvironmentInstance>();
    }

    public get setEnvironment(): Action<EnvironmentInstance> {
        return this._setEnvironment;
    }

    private _setEnvironment: Action<EnvironmentInstance>;
}
